module.exports = __webpack_public_path__ + "img/woman.bf08db59.webp";